import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastService } from '../../@theme/service/toast.service';
import { AccountService } from '../account/account.service';
import { NbStepperComponent } from '@nebular/theme';
import { CompanyService } from '../company/company.service';
import { UsersService } from './user.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Request } from '../request/request';
import { RequestService } from '../request/request.service';
import { Strings } from '../../common/util/Strings';
import { IPUtil } from '../../common/util/ip.util';
import { ServerService } from '../../@theme/service/connection.service';
import { RequestContext } from '../request/request-context';
import { Company } from '../../common/model/company';
import { ActivatedRoute } from '@angular/router';
import { Objects } from '../../common/util/objects';
import CryptoES from 'crypto-es';
import { EncryptRSA } from '../../common/util/encrypt-rsa.util';

@Component({
  selector: 'ngx-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit, AfterViewInit {
  @ViewChild('stepper', { static: false })
  stepperComponent: NbStepperComponent;

  @ViewChild('inputStep1', { static: false }) inputStep1: ElementRef; // 담당자 Email
  @ViewChild('inputStep2', { static: false }) inputStep2: ElementRef; // 그룹코드
  @ViewChild('inputStep3', { static: false }) inputStep3: ElementRef; // Email
  @ViewChild('inputStep3N', { static: false }) inputStep3N: ElementRef; // 이름
  @ViewChild('inputStep3J', { static: false }) inputStep3J: ElementRef; // 직급
  @ViewChild('inputStep3P', { static: false }) inputStep3P: ElementRef; // 연락처
  @ViewChild('inputStep3A', { static: false }) inputStep3A: ElementRef; // 인증코드
  @ViewChild('inputStep3Pass', { static: false }) inputStep3Pass: ElementRef; // 비밀번호
  @ViewChild('inputStep3PassRe', { static: false }) inputStep3PassRe: ElementRef; // 비밀번호 재입력
  @ViewChild('inputStep4', { static: false }) inputStep4: ElementRef; // RemoteIP
  @ViewChild('inputStep4N', { static: false }) inputStep4N: ElementRef; // LocalIP

  step1: FormGroup; // 담당자Email
  step2: FormGroup; // 그룹코드
  step3: FormGroup; // 사용자 정보
  step4: FormGroup; // 허용IP
  step5: FormGroup; // 인증코드
  step6: FormGroup; // 비밀번호

  isUserName = false;
  isLoading = false;
  isLast = false;
  useAllowIp = true;
  useAuthPass: boolean = true; // 비밀번호 사용여부
  authTypeName = 'Email';
  isAuthEmail = true;
  useAuthCode = "EMAIL";
  encryptor: EncryptRSA;

  public info: RequestContext = new RequestContext();

  constructor(
    private fb: FormBuilder,
    private changeDetector: ChangeDetectorRef,
    private toastService: ToastService,
    private accountService: AccountService,
    private companyService: CompanyService,
    private usersService: UsersService,
    private serverService: ServerService,
    private requestService: RequestService,
    private route: ActivatedRoute
  ) {}

  ngAfterViewInit() {
    this.inputStep1.nativeElement.focus();
  }

  ngOnInit() {

    const ticketId = this.route.snapshot.queryParamMap.get('tid');
    if (!Strings.isEmpty(ticketId)) {
      this.info.ticketId = ticketId;
    }

    this.step1 = this.fb.group({
      accountEmail: ['', Validators.required],
      accountName: ['', Validators.required],
      accountId: ['', Validators.required],
    });
    this.step2 = this.fb.group({
      companyCode: ['', Validators.required],
      companyName: ['', Validators.required],
      companyId: ['', Validators.required],
    });
    this.step3 = this.fb.group({
      userEmail: ['', Validators.required],
      userName: ['', Validators.required],
      authCode: this.isAuthEmail ? ['', Validators.required] : [],
      authPasswd: this.useAuthPass ? ['', Validators.required] : [],
      authPasswdRe: this.useAuthPass ? ['', Validators.required] : [],
      userId: ['', Validators.required],
      jobTitle: [''],
      phoneNumber: [''],
    });
    // this.step4 = this.fb.group({
    //   remoteIp: ['', Validators.required],
    //   localIp: ['', Validators.required],
    // });
  }

  onStepSubmit(setp: number) {
    switch (setp) {
      case 1:
        this.step1.markAsDirty();
        const accountEmail = this.step1.get('accountEmail').value;
        if (!accountEmail) {
          this.toastService.showToast(
            'warning',
            '담당자의 이메일주소를 입력해 주세요.',
            '',
          );
          this.inputStep1.nativeElement.focus();
          return;
        }
        this.findByAccountEmail(accountEmail);
        break;
      case 2:
        this.step2.markAsDirty();
        const companyCode = this.step2.get('companyCode').value;
        if (!companyCode) {
          this.toastService.showToast(
            'warning',
            '그룹코드를 입력해 주세요.',
            '',
          );
          this.inputStep2.nativeElement.focus();
          return;
        }
        // this.findByCompanyCode(companyCode);
        break;
      case 3:
        this.step3.markAsDirty();
        const userEmail = this.step3.get('userEmail').value;
        if (!userEmail) {
          this.toastService.showToast(
            'warning',
            '신청자의 이메일주소를 입력해 주세요.',
            '',
          );
          this.inputStep3.nativeElement.focus();
          return;
        }

        if (!this.isUserName) {
          this.findByUser(userEmail);
        } else {

          const userName = this.step3.get('userName').value;

          if (Strings.isBlank(userName)) {
            this.toastService.showToast('warning', '신청자 이름을 입력해 주세요.', '');
            this.inputStep3N.nativeElement.focus();
            return;
          }

          const jobTitle = this.inputStep3J.nativeElement.value;

          if (Strings.isBlank(jobTitle)) {
            this.toastService.showToast('warning', '신청자 직급을 입력해 주세요.', '');
            this.inputStep3J.nativeElement.focus();
            return;
          }

          const authCode = this.isAuthEmail ? userEmail : this.inputStep3A.nativeElement.value;

          if (!this.isAuthEmail && Strings.isBlank(authCode)) {
            this.toastService.showToast('warning', '인증코드를 입력해 주세요.', '');
            this.inputStep3A.nativeElement.focus();
            return;
          }

          const authPasswd = this.inputStep3Pass.nativeElement.value;
          const authPasswdRe = this.inputStep3PassRe.nativeElement.value;

          if (this.useAuthPass) {
            if (Strings.isBlank(authPasswd)) {
              this.toastService.showToast('warning', '비밀번호를 입력해 주세요.', '');
              this.inputStep3Pass.nativeElement.focus();
              return;
            }

            if (Strings.isBlank(authPasswdRe)) {
              this.toastService.showToast('warning', '비밀번호 재확인 필드를 입력해 주세요.', '');
              this.inputStep3PassRe.nativeElement.focus();
              return;
            }

            if (!Strings.equal(authPasswd, authPasswdRe)) {
              this.toastService.showToast('warning', '입력한 비밀번호가 다릅니다.', '');
              this.inputStep3PassRe.nativeElement.focus();
              return;
            }
          }
          
          const phoneNumber = this.inputStep3P.nativeElement.value;

          // 카톡을 받을경우에만 사용됨
          // if (Strings.isBlank(phoneNumber)) {
          //   this.toastService.showToast('warning', '신청자 연락처를 입력해 주세요.', '');
          //   this.inputStep3P.nativeElement.focus();
          //   return;
          // }
          this.step3.get('userId').setValue('new');
          this.info.userEmail = userEmail;
          this.info.userName = userName;
          this.info.phoneNumber = phoneNumber;
          this.info.jobTitle = jobTitle;
          this.info.authCode = this.encryptor.encrypt(authCode);
          this.info.authPassword = this.encryptor.encrypt(authPasswd);
          this.stepperComponent.next();
          this.changeDetector.detectChanges();
          
          // TODO 허용IP 제거 2023-05-10
          // this.inputStep4.nativeElement.focus();
          // this.getIpAddress();

          if (!this.info.userId || this.info.userId === 'new') {
            this.save();
          } else {
            // this.findByUserId(this.info.userId);
          }

          this.isUserName = false;
        }
        break;
      // case 4:
      //   this.step4.markAsDirty();
      //   const remoteIp = this.step4.get('remoteIp').value;
      //   const localIp = this.step4.get('localIp').value;

      //   if (!this.vaildateIp(remoteIp, true)) {
      //     this.inputStep4.nativeElement.focus();
      //     return;
      //   }

      //   if (!this.vaildateIp(localIp, false)) {
      //     this.inputStep4N.nativeElement.focus();
      //     return;
      //   }

      //   this.info.ips = [];
      //   if (!this.info.userId || this.info.userId === 'new') {
      //     this.save(remoteIp, localIp);
      //   } else {
      //     this.findByUserId(this.info.userId);
      //   }
      //   break;
    }
  }

  prev(currentStep: number) {

    console.log(currentStep);

    switch (currentStep) {
      case 2:
        this.step2.get('companyCode').setValue('');
        this.step2.get('companyName').setValue('');
        this.step2.get('companyId').setValue('');
        setTimeout(()=> {
          this.step1.markAsPristine();
          this.inputStep1.nativeElement.focus();
        }, 100);
        break;
      case 3:
        this.step3.get('userId').setValue('');
        this.step3.get('userEmail')?.setValue('');

        if (this.isUserName) {
          this.step3.get('userName')?.setValue('');
          this.step3.get('jobTitle')?.setValue('');
          this.step3.get('phoneNumber')?.setValue('');
        }

        if (!this.isAuthEmail)
          this.step3.get('authCode')?.setValue('');

        if (this.useAuthPass) {
          this.step3.get('authPasswd')?.setValue('');
          this.step3.get('authPasswdRe')?.setValue('');
        }

        this.isUserName = false;
        setTimeout(()=> {
          this.step2.markAsPristine();
          this.inputStep2.nativeElement.focus();
        });
        break;
      case 4:
        this.step4.get('remoteIp').setValue('');
        this.step4.get('localIp').setValue('');
        setTimeout(()=> {
          this.step3.markAsPristine();
        this.inputStep3.nativeElement.focus();
        });
        break;
    }

    this.stepperComponent.previous();
  }

  vaildateIp(ipAddress: string, isRemote: boolean): boolean {
    if (Strings.isBlank(ipAddress)) {
      this.toastService.showToast('warning', isRemote ? '허용할 Remote IP를 입력해 주세요.' : '허용할 Local IP를 입력해 주세요.');
      return false;
    }

    if (!IPUtil.isIpv4String(ipAddress)) {
      this.toastService.showToast('warning', isRemote ? '올바른 Remote IP를 입력해 주세요.' : '올바른 Local IP를 입력해 주세요.');
      return false;
    }

    return true;
  }

  getIpAddress() {
    this.serverService.connection().subscribe((res) => {
      if (res && res.result)
        this.step4.get('remoteIp').setValue(res.data.remoteIp);
    });
  }

  findByAccountEmail(accountEmail: string) {
    this.accountService.findByEmail(accountEmail).subscribe((d: any) => {
      if (!d.data) {
        this.toastService.showToast(
          'warning',
          '등록된 이메일주소가 없습니다.',
          '다시 확인해 주세요.',
        );
        this.step1.get('accountName').setValue('');
        this.step1.get('accountId').setValue('');
        return;
      } else if (d.data.state == 'INACTIVE') {
        this.toastService.showToast(
          'warning',
          '담당자 이메일을 입력해 주세요.',
          '',
        );
        this.step1.get('accountName').setValue('');
        this.step1.get('accountId').setValue('');
        return;
      }
      this.step1.get('accountName').setValue(d.data.name);
      this.step1.get('accountId').setValue(d.data.id);
      this.info.accountEmail = accountEmail;
      this.info.accountName = d.data.name;
      this.info.accountId = d.data.id;
      this.info.companyId = d.data.companyId;
      this.stepperComponent.next();
      this.changeDetector.detectChanges();
      this.inputStep2.nativeElement.focus();
    });
  }

  /**
   * Email로 사용자를 찾고 동일 Email 사용자가 있는경우
   * 이미 등록된 사용자로 클라이언트 사용신청 중단
   * 없으면 신규 사용자 등록
   * @param userEmail 
   */
  findByUser(userEmail: string) {
    const exist = new Promise((resolve, reject) => {
      this.requestService.existsEmail(userEmail).subscribe(res => {
        if (res && res.result) {
          resolve(res.data);
        } else {
          reject(false);
        }
      }, error => reject(error));
    });

    exist.then(res => {
      if (res == 'WAIT') {
        this.toastService.showToast(
          'warning',
          '이미 신청된 사용자 입니다.',
          '관리자 또는 담당자에게 문의해 주세요.',
        );
        this.step3.get('userName').setValue('');
        this.step3.get('userId').setValue('');
        this.isUserName = false;
        setTimeout(() => {
          this.inputStep3N.nativeElement.focus();
        }, 100);
        return;
      } else if (res == 'NOT_EXISTS') {
        this.usersService.findByEmail(userEmail).subscribe((d: any) => {
          const user: any = d.data?.content[0] || null;
    
          if (!user) {
            this.toastService.showToast(
              'info',
              '신규사용자',
              '신청자 정보를 입력해 주세요.',
            );
            this.step3.get('userName').setValue('');
            this.step3.get('userId').setValue('');
            this.isUserName = true;
            setTimeout(() => {
              this.inputStep3N.nativeElement.focus();
            }, 100);
            return;
          } else if (user.companyId != this.info.companyId) {
            this.toastService.showToast(
              'warning',
              '기존사용자의 그룹을 변경 할 수 없습니다.',
              '관리자 또는 담당자에게 문의해 주세요.',
            );
            this.step3.get('userName').setValue('');
            this.step3.get('userId').setValue('');
            this.isUserName = false;
            setTimeout(() => {
              this.inputStep3N.nativeElement.focus();
            }, 100);
            return;
          } else {
            this.toastService.showToast(
              'warning',
              '이미 등록된 사용자 입니다.',
              '관리자 또는 담당자에게 문의해 주세요.',
            );
            this.step3.get('userName').setValue('');
            this.step3.get('userId').setValue('');
            this.isUserName = false;
            setTimeout(() => {
              this.inputStep3N.nativeElement.focus();
            }, 100);
            return;
          }
        });
      } else {
        this.toastService.showToast(
          'warning',
          '이미 등록된 사용자 입니다.',
          '관리자 또는 담당자에게 문의해 주세요.',
        );
        this.step3.get('userName').setValue('');
        this.step3.get('userId').setValue('');
        this.isUserName = false;
        setTimeout(() => {
          this.inputStep3N.nativeElement.focus();
        }, 100);
        return;
      }
    }).catch(() => {
      this.toastService.showToast(
        'warning',
        '알 수 없는 문제가 발생 되었습니다.',
        '관리자 또는 담당자에게 문의해 주세요.',
      );
      this.step3.get('userName').setValue('');
      this.step3.get('userId').setValue('');
      this.isUserName = false;
      setTimeout(() => {
        this.inputStep3N.nativeElement.focus();
      }, 100);
      return;
    });
    
  }

  save() {

    const request = new Request();
    if (this.info.userId === 'new') {
      this.info.userId = '';
    }

    request.createdBy = this.info.userName;
    request.companyId = this.info.companyId;
    request.accountId = this.info.accountId;
    request.email = this.info.userEmail;
    request.context = this.info;

    this.isLoading = true;
    this.requestService.create(request).subscribe(
      (d) => {
        this.isLoading = false;

        if (d.result) {
          this.isLast = true;
          this.changeDetector.detectChanges();
        } else {
          this.toastService.showToast(
            'warning',
            '이미 신청된 사용자입니다.',
          );  
        }
      },
      (e: HttpErrorResponse) => {
        this.isLoading = false;
        this.toastService.showToast(
          'danger',
          '응답시간이 초과되었습니다.',
          '잠시 후 다시 이용해주세요.',
        );
        console.error(e);
      },
    );
  }

  reset() {
    this.isLast = false;
    setTimeout(() => {
      this.stepperComponent.reset();
      this.inputStep1.nativeElement.focus();
    }, 100);
  }
}
